import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'No tengo tiempo para esto',
    a: 'Precisamente por eso lo creamos. El protocolo se basa en cambios de 10-20 minutos al día: el timing de tus comidas, exposición a la luz, una ducha fría de 90 segundos. La app te dice exactamente qué hacer — abres, sigues la checklist, cierras. Sin pensar.'
  }, {
    q: '¿Es una dieta tipo Keto o Vegana?',
    a: 'No. Bio-X 90 es agnóstico a las etiquetas. Se basa en biomarcadores y ciencia metabólica. Comerás comida real, deliciosa y sostenible. Solo eliminamos 3 agentes tóxicos específicos (aceites industriales, azúcar refinada y gluten procesado) y optimizamos el timing.'
  }, {
    q: '¿Necesito comprar equipo o suplementos caros?',
    a: 'Cero equipo. Las herramientas principales son gratuitas: sol, agua, luz y timing. Los suplementos recomendados son 4 básicos que cuestan menos de $30/mes total. Nada de stacks de $500.'
  }, {
    q: '¿La app funciona en mi teléfono?',
    a: 'Es una app web (PWA) que funciona en CUALQUIER dispositivo con navegador: iPhone, Android, iPad, laptop o desktop. No necesitas descargar nada de una tienda. Abres el link y listo.'
  }, {
    q: '¿Qué diferencia hay entre esto y cualquier libro de biohacking?',
    a: 'Los libros te dan información. BIO-X 90 te da ACCIÓN. La app convierte 60 páginas de ciencia en una checklist diaria interactiva con timer, tracker, calculadoras y gamificación. En 30 segundos sabes qué hacer hoy. No en 30 páginas.'
  }, {
    q: '¿Y si no funciona para mí?',
    a: 'Tienes 7 días para probarlo completamente. Si no sientes que el sistema te ayuda a ordenar tus hábitos, si no notas mejoras en tu energía diaria, o simplemente no te gusta — envíanos un email y te devolvemos cada centavo. Sin preguntas. El riesgo es 100% nuestro.'
  }, {
    q: '¿Por qué solo $6.36 si vale más de $1,000?',
    a: 'Porque es nuestro lanzamiento. Queremos que 1,000 ejecutivos prueben el sistema completo, dejen resultados documentados, y se conviertan en embajadores. Este precio NO durará. Cuando cerremos la oferta de lanzamiento, el precio sube a mínimo $97.'
  }];
  return <section className="py-24 px-6 bg-brand-bg-alt" data-id="element-326">
      <div className="max-w-[800px] mx-auto" data-id="element-327">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-328">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-329">
            Preguntas Que Probablemente Tienes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-330">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.05
        }} className="bg-brand-card rounded-2xl border border-brand-border overflow-hidden" data-id="element-331">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none" data-id="element-332">
                <span className="font-bold text-white pr-8" data-id="element-333">{faq.q}</span>
                {openIndex === idx ? <Minus className="w-5 h-5 text-brand-cyan shrink-0" data-id="element-334" /> : <Plus className="w-5 h-5 text-brand-muted shrink-0" data-id="element-335" />}
              </button>
              <AnimatePresence data-id="element-336">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-337">
                    <div className="px-6 pb-6 text-brand-muted leading-relaxed border-t border-brand-border pt-4" data-id="element-338">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}